import { FragmentOf, gql } from '@/utilities/gql';

export const COMPANY_FRAGMENT = gql(`
  fragment CompanyFields on Company @_unmask {
    id
    name
    tickerSymbol
    uniqueSymbol
    data {
      marketCap
      currencyInfo
    }
    analysisFuture {
      revenueGrowthAnnual
      netIncomeGrowthAnnual
      forwardPe1Y
      forwardPriceToSales1Y
    }
    exchangeCountryISO
    info {
      url
    }
    primaryIndustry {
      name
      friendlyName
      industryAverages {
        name
        value
      }
    }
    secondaryIndustry {
      name
      friendlyName
      industryAverages {
        name
        value
      }
    }
    analysisDividend {
      dividendYield
    }
    score {
      value
      future
      past
      health
      dividend
      sentence
    }
    analysisValue {
      intrinsicValue
      pe
      pb
      priceToSales
      preferredRelativeMultiple
      lastSharePrice
      npvPerShare
      marketCapUSD
      intrinsicDiscount
      return7d
      return30d
      return90d
      return1yAbs
      priceTarget
      priceTargetAnalystCount
    }
    analysisPast {
      netIncome
      netIncomeMargin
      revenue
      netIncomeLtmHistory
      revenueLtmHistory
    }
    analysisMisc {
      analystCount
      sharesOutstandingSingleGrowth1Y
    }
    canonicalURL
  }
`);

export type Company = FragmentOf<typeof COMPANY_FRAGMENT>;
